import { axiosInstance } from "../axios/axiosConfig";
import { CONTACT_US_API } from "../constants/api-constants";

export const postContactUs = async (payload) => {
    try {
        const response = await axiosInstance.post(CONTACT_US_API.POST_CONTACT_US_API, payload);
        return response.data;
    } catch (error) {
        return error;
    }
};
